module.exports = __webpack_public_path__ + "6b7aad96222f624c94b1c5b0b02263d9.jpg";